export const ContactUsScrollType = {
  TechnicalSupport: 'ts',
  CustomerService: 'cs',
  SalesInquiries: 'si',
  MediaInquiries: 'mi'
};
